<template>
  <v-card height="400px">
    <v-card-title>
      <span class="text-h5">{{ $t('admin.users.createUserAndProfile') }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="newItem.email" 
              :label="$t('login.email')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="newItem.username"
              :label="$t('admin.users.username')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="newItem.password"
              :label="$t('login.password')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="resetNewItem"> {{ $t('forms.cancel')}} </v-btn>
      <ApolloMutation
        :mutation="(gql) => registerUserQuery"
        :variables="{
          email: newItem.email,
          username: newItem.username,
          password: newItem.password,
        }"
        @done="resetNewItem"
      >
        <template v-slot="{ mutate, loading, error }">
          <v-btn
            :loading="loading"
            color="blue darken-1"
            @click="mutate({ refetchQueries: ['GetUsers'] })"
          >
          {{ $t('forms.save')}}
          </v-btn>
          {{ error }}
        </template>
      </ApolloMutation>
    </v-card-actions>
  </v-card>
</template>
<script>
import { REGISTER_USER } from "@/graphql/AuthMutations";
export default {
  props: {
    availableRoles: Array,
  },
  data() {
    return {
      newItem: {},
    }
  },
  methods:{
    resetNewItem() {
      this.newItem = {};
      this.$emit('dialog', false);
    },
  },
  computed: {
    registerUserQuery() {
      return REGISTER_USER;
    }
  },
}
</script>